export default "__VITE_ASSET__CSweFQeP__"